// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__Z62E9","l4":"styles_l4__aeJXA","redir":"styles_redir__qjW9E"};